/* istanbul ignore file */
import { appendReduxPart } from "infrastructure/store";

import TermTranslations from "./TermTranslations";
import { termTranslationsSaga } from "./TermTranslations.saga";
import { termTranslations } from "./TermTranslations.slice";

export * from "./TermTranslations.actions";
export * from "./TermTranslations.state";
export { TermTranslations };

appendReduxPart(
  {
    reducerName: termTranslations.name,
    reducer: termTranslations.reducer
  },
  termTranslationsSaga()
);
